export function censurePhoneContent(phone: string | undefined) {
    const start = (phone || '').slice(0, 5);
    const end = (phone || '').slice((phone || '').length - 2, (phone || '').length);

    return `${start}...${end}`;
}

export default censurePhoneContent;
